/** Polyfills **/

/** === CSS vars === **/
// --- https://codepen.io/aaronbarker/pen/MeaRmL
let cssVarPoly = {
  init() {
    if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
      return
    } else {
      document.querySelector('body').classList.add('cssvars-polyfilled')
    }

    cssVarPoly.ratifiedVars = {}
    cssVarPoly.varsByBlock = {}
    cssVarPoly.oldCSS = {}

    cssVarPoly.findCSS()
    cssVarPoly.updateCSS()
  },

  findCSS() {
    if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) return

    let styleBlocks = document.querySelectorAll('style:not(.inserted),link[type="text/css"]')
    let counter = 1

    Array.prototype.forEach.call(styleBlocks, function(block) {
      let theCSS
      if (block.nodeName === 'STYLE') {
        theCSS = block.innerHTML
        cssVarPoly.findSetters(theCSS, counter)
      } else if (block.nodeName === 'LINK') {
        cssVarPoly.getLink(block.getAttribute('href'), counter, function(counter, request) {
          cssVarPoly.findSetters(request.responseText, counter)
          cssVarPoly.oldCSS[counter] = request.responseText
          cssVarPoly.updateCSS()
        })
        theCSS = ''
      }
      if (cssVarPoly.oldCSS) {
        cssVarPoly.oldCSS[counter] = theCSS
      }
      counter++
    })
  },

  findSetters(theCSS, counter) {
    if (cssVarPoly.varsByBlock) {
      cssVarPoly.varsByBlock[counter] = theCSS.match(/(--.+:.+;)/g) || []
    }
  },

  updateCSS() {
    if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) return

    cssVarPoly.ratifySetters(cssVarPoly.varsByBlock)

    for (let curCSSID in cssVarPoly.oldCSS) {
      let newCSS = cssVarPoly.replaceGetters(cssVarPoly.oldCSS[curCSSID], cssVarPoly.ratifiedVars)

      if (document.querySelector('#inserted' + curCSSID)) {
        document.querySelector('#inserted' + curCSSID).innerHTML = newCSS
      } else {
        var style = document.createElement('style')
        style.type = 'text/css'
        style.innerHTML = newCSS
        style.classList.add('inserted')
        style.id = 'inserted' + curCSSID
        document.getElementsByTagName('head')[0].appendChild(style)
      }
    }
  },

  replaceGetters(curCSS, varList) {
    for (let theVar in varList) {
      let getterRegex = new RegExp('var\\(\\s*' + theVar + '\\s*\\)', 'g')

      curCSS = curCSS.replace(getterRegex, varList[theVar])

      let getterRegex2 = new RegExp('var\\(\\s*.+\\s*,\\s*(.+)\\)', 'g')

      let matches = curCSS.match(getterRegex2)
      if (matches) {
        matches.forEach(function(match) {
          curCSS = curCSS.replace(match, match.match(/var\(.+,\s*(.+)\)/)[1])
        })
      }
    }

    return curCSS
  },

  ratifySetters(varList) {
    for (let curBlock in varList) {
      let curVars = varList[curBlock]

      curVars.forEach(function(theVar) {
        let matches = theVar.split(/:\s*/)
        cssVarPoly.ratifiedVars[matches[0]] = matches[1].replace(/;/, '')
      })
    }
  },

  getLink(url, counter, success) {
    var request = new XMLHttpRequest()
    request.open('GET', url, true)
    request.overrideMimeType('text/css;')
    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
        if (typeof success === 'function') {
          success(counter, request)
        }
      } else {
        console.warn('an error was returned from:', url)
      }
    }

    request.onerror = function() {
      console.warn('we could not get anything from:', url)
    }

    request.send()
  }
}
global.cssVarPoly = cssVarPoly

/** === String includes === **/
// --- https://developer.mozilla.org/it/docs/Web/JavaScript/Reference/Global_Objects/String/includes#Polyfill
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) { // eslint-disable-line
    'use strict'
    if (typeof start !== 'number') {
      start = 0
    }

    if (start + search.length > this.length) {
      return false
    } else {
      return this.indexOf(search, start) !== -1
    }
  }
}

/** === Array find === **/
// --- https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', { // eslint-disable-line
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined')
      }

      var o = Object(this)

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function')
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1]

      // 5. Let k be 0.
      var k = 0

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k]
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue
        }
        // e. Increase k by 1.
        k++
      }

      // 7. Return undefined.
      return undefined
    }
  })
}

/** === Array forEach === **/
// --- Production steps of ECMA-262, Edition 5, 15.4.4.18
// --- Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function(callback/*, thisArg*/) { // eslint-disable-line
    var T, k

    if (this == null) {
      throw new TypeError('this is null or not defined')
    }

    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this)

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0

    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function')
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = arguments[1]
    }

    // 6. Let k be 0.
    k = 0

    // 7. Repeat while k < len.
    while (k < len) {
      var kValue

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator.
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c.
      // c. If kPresent is true, then
      if (k in O) {
        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k]

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O)
      }
      // d. Increase k by 1.
      k++
    }
    // 8. return undefined.
  }
}

/** === vue-router IE fix === **/
// https://github.com/vuejs/vue-router/issues/1849
if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
  window.addEventListener('hashchange', () => {
    var currentPath = window.location.hash.slice(1)
    if (global.app.$router.currentRoute.path !== currentPath) {
      global.app.$router.push(currentPath)
    }
  }, false)
}

/** === array.findindex IE fix === */
// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined')
      }

      var o = Object(this)

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function')
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1]

      // 5. Let k be 0.
      var k = 0

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k]
        if (predicate.call(thisArg, kValue, k, o)) {
          return k
        }
        // e. Increase k by 1.
        k++
      }

      // 7. Return -1.
      return -1
    },
    configurable: true,
    writable: true
  })
}
//

/** === string starts with IE fix === */
if (!String.prototype.startsWith) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function(search, rawPos) {
      var pos = rawPos > 0 ? rawPos | 0 : 0
      return this.substring(pos, pos + search.length) === search
    }
  })
}



// WEBPACK FOOTER //
// ./src/core/utils/polyfills.js